
import { EmptyState, Page , Card} from "@shopify/polaris";
import React from "react";
import { DIProps } from "../../../Core";
import sessionTimeout from '../../../Asests/Images/sessionTimeout.png';
import { useTranslation } from "react-i18next";

export function ShowLogOutScreen(props: DIProps): JSX.Element {
    const { t } = useTranslation();
    return (
        <Page>
            <Card>
                <EmptyState
                    image={sessionTimeout}
                    heading={t("Session Expired")}
                />
            </Card>
        </Page>
    );
}